import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';

const controller = '360/order';

/**
 * Get Last Order
 *
 * @param {Number} pmwebId
 */
export const getLastOrder = pmwebId => {
  const brand = store.getters.selectedBrand;
  const tokenV3 = store.state.auth.tokenV3;

  return axios
    .get(`${controller}/getLastOrder`, {
      baseURL: endpointVersion('v3'),
      params: {
        brand: brand.id,
        pid: pmwebId,
      },
      headers: { Authorization: `Bearer ${tokenV3}` },
    })
    .then(data => data.data);
};
